import { ReportFilterOperation, ReportValue } from '@driftt/api-types'

import { isNilOrEmpty } from 'utils/ramda'

import { filterCreator } from '../query/creators'
import QueryBuilder from '../query/QueryBuilder'

const FILTER_BY_OPTIONS = Object.freeze({
  agentsSelected: filterCreator('agentId', ReportFilterOperation.IN),
})

export const filterForType = (
  filterType: string,
  filterValue: ReportValue | ReportValue[]
) => FILTER_BY_OPTIONS[filterType](filterValue)

export default class ServiceQueryBuilder extends QueryBuilder {
  constructor() {
    super()
  }

  public withFilterGroups(q: any) {
    if (q.compoundQuery && !isNilOrEmpty(q.compoundQuery)) {
      const mappedCompoundQuery = q.compoundQuery.map((query) => {
        if (query.property === 'agentId') {
          return {
            ...query,
            property: 'latestLiveChatRating.attributedRatingAgentId',
          }
        } else {
          return query
        }
      })

      this.filterGroups.push({
        negateFilterGroup: false,
        shouldMatch: q.compoundQuery.length,
        filters: mappedCompoundQuery,
      })
    }

    return this
  }

  public withFilterType(type, value) {
    this.filters.push(filterForType(type, value))
  }
}
